import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams, useSearchParams } from "react-router-dom";
import Layout from "@/components/Layout";
import LiquidLayout from "@/components/LiquidLayout";
import LiquidAtlasHome from "@/pages/LiquidAtlasHome";
import SpiritsHome from "@/pages/SpiritsHome";
import SpiritsCategory from "@/pages/SpiritsCategory";
import SpiritsItem from "@/pages/SpiritsItem";
import Home from "@/pages/Home";
import Explore from "@/pages/Explore";
import GinDetail from "@/pages/GinDetail";
import Matchmaker from "@/pages/Matchmaker";
import Compare from "@/pages/Compare";
import Surprise from "@/pages/Surprise";
import Flights from "@/pages/Flights";
import FlightDetail from "@/pages/FlightDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminMenu from "@/pages/admin/AdminMenu";
import AdminGinEditor from "@/pages/admin/AdminGinEditor";
import AdminIntelligence from "@/pages/admin/AdminIntelligence";
import AdminRecommendations from "@/pages/admin/AdminRecommendations";
import AdminMenuGaps from "@/pages/admin/AdminMenuGaps";
import AdminAlerts from "@/pages/admin/AdminAlerts";
import AdminFlights from "@/pages/admin/AdminFlights";
import AdminTonight from "@/pages/admin/AdminTonight";
import AdminEnrichment from "@/pages/admin/AdminEnrichment";
import AdminEnrichmentQueue from "@/pages/admin/AdminEnrichmentQueue";
import AdminSources from "@/pages/admin/AdminSources";
import AdminMenuUpload from "@/pages/admin/AdminMenuUpload";
import AdminBeverages from "@/pages/admin/AdminBeverages";
import AdminBeverageEditor from "@/pages/admin/AdminBeverageEditor";

// Redirect old gin routes → new /gin/* namespace, preserving id & query
function RedirectToGinDetail() {
  const { id } = useParams();
  const [sp] = useSearchParams();
  const qs = sp.toString();
  return <Navigate to={`/gin/g/${id}${qs ? `?${qs}` : ""}`} replace />;
}

function RedirectStatic({ to }) {
  const [sp] = useSearchParams();
  const qs = sp.toString();
  return <Navigate to={`${to}${qs ? `?${qs}` : ""}`} replace />;
}

function RedirectFlightDetail() {
  const { id } = useParams();
  return <Navigate to={`/gin/flights/${id}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin routes — separate shell */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="menu" element={<AdminMenu />} />
          <Route path="menu/:id" element={<AdminGinEditor />} />
          <Route path="menu/:id/enrich" element={<AdminEnrichment />} />
          <Route path="enrichment" element={<AdminEnrichmentQueue />} />
          <Route path="sources" element={<AdminSources />} />
          <Route path="intelligence" element={<AdminIntelligence />} />
          <Route path="recommendations" element={<AdminRecommendations />} />
          <Route path="menu-gaps" element={<AdminMenuGaps />} />
          <Route path="alerts" element={<AdminAlerts />} />
          <Route path="flights" element={<AdminFlights />} />
          <Route path="tonight" element={<AdminTonight />} />
          <Route path="menu-upload" element={<AdminMenuUpload />} />
          <Route path="beverages" element={<AdminBeverages />} />
          <Route path="beverages/:id" element={<AdminBeverageEditor />} />
        </Route>

        {/* Public routes */}
        <Route path="*" element={
          <Routes>
            {/* NEW: Liquid Atlas landing + Spirits Menu — minimal shell */}
            <Route path="/" element={<LiquidLayout><LiquidAtlasHome /></LiquidLayout>} />
            <Route path="/spirits" element={<LiquidLayout><SpiritsHome /></LiquidLayout>} />
            <Route path="/spirits/item/:id" element={<LiquidLayout><SpiritsItem /></LiquidLayout>} />
            <Route path="/spirits/:category" element={<LiquidLayout><SpiritsCategory /></LiquidLayout>} />

            {/* Gin Atlas — flagship, full deep shell */}
            <Route path="/gin" element={<Layout><Home /></Layout>} />
            <Route path="/gin/explore" element={<Layout><Explore /></Layout>} />
            <Route path="/gin/match" element={<Layout><Matchmaker /></Layout>} />
            <Route path="/gin/compare" element={<Layout><Compare /></Layout>} />
            <Route path="/gin/surprise" element={<Layout><Surprise /></Layout>} />
            <Route path="/gin/flights" element={<Layout><Flights /></Layout>} />
            <Route path="/gin/flights/custom" element={<Layout><FlightDetail /></Layout>} />
            <Route path="/gin/flights/:id" element={<Layout><FlightDetail /></Layout>} />
            <Route path="/gin/g/:id" element={<Layout><GinDetail /></Layout>} />

            {/* Backwards-compatible redirects for old links / QR codes */}
            <Route path="/explore" element={<RedirectStatic to="/gin/explore" />} />
            <Route path="/match" element={<RedirectStatic to="/gin/match" />} />
            <Route path="/compare" element={<RedirectStatic to="/gin/compare" />} />
            <Route path="/surprise" element={<RedirectStatic to="/gin/surprise" />} />
            <Route path="/flights" element={<RedirectStatic to="/gin/flights" />} />
            <Route path="/flights/custom" element={<RedirectStatic to="/gin/flights/custom" />} />
            <Route path="/flights/:id" element={<RedirectFlightDetail />} />
            <Route path="/gin/:id" element={<RedirectToGinDetail />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        } />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
